import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { PermisisonAddSchema } from "../../../ValidationSchema";

const PermissionAdd = () => {
  const Navigate = useNavigate();
  const [initialValues] = useState({
    name: "",
    permission_name: "",
  });

  const AddRole = useFormik({
    initialValues,
    validationSchema: PermisisonAddSchema,

    onSubmit: (values, action) => {
      axios
        .post(`${process.env.REACT_APP_URL}/admin/permission/store`, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            Navigate("/admin/permission", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  //   const UserRole = () => {
  //     axios
  //       .get(`${process.env.REACT_APP_URL}/common/roles`)
  //       .then((res) => {
  //         setUserRole(res.data.roles);
  //       })
  //       .catch((err) => {
  //         if (err.response.data.message === "Unauthorized!") {
  //           Navigate("/admin/login");
  //         }
  //       });
  //   };

  useEffect(() => {
    // UserRole();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Add Permission</h1>
          <p className="al-sub">Create a new permission.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddRole.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg></div>
            <h3 className="al-cardhead__title">Permission Details</h3>
          </div>
          <div className="al-form">
            <div>
              <label className="al-label">Name</label>
              <input className="al-input" type="text" placeholder="Enter Name"
                value={AddRole.values.name} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="name" />
              {AddRole.errors.name && AddRole.touched.name && (
                <div className="al-err">{AddRole.errors.name}</div>
              )}
            </div>
            <div>
              <label className="al-label">Permission Name</label>
              <input className="al-input" type="text" placeholder="Enter Permission Name"
                value={AddRole.values.permission_name} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="permission_name" />
              {AddRole.errors.permission_name && AddRole.touched.permission_name && (
                <div className="al-err">{AddRole.errors.permission_name}</div>
              )}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Create Permission
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PermissionAdd;
